module.exports = __webpack_public_path__ + "static/media/vial.6c8253c7.svg";